<template>
	<div>
		<Row>
			<Button type="success" style="float:right;" icon="md-add" @click="addProjectType">添加类型</Button>
		</Row>
		<div class="margin-top-10">
			<Card>
				<Table width="100%" row-key="id" :data="treeData" :columns="projectTypeCloumn">
					<template slot-scope="{ row, index }" slot="action">
						<Button type="info" @click="remove(row)">删除</Button>
					</template>
				</Table>
			</Card>
		</div>
		<Modal v-model="addProjectTypeModal" :title="addProjectTypeModalTitle" :mask="true" :mask-closable="false" :footer-hide="true">
			<Form :model="projectTypeItem">
				<FormItem label="上级类型">
					<!-- 	<Select v-model="projectTypeItem.parentId">
						<Option v-for="item in projectTypeList"  :label="item.name"  :value="item.id"></Option>
					</Select> -->
					<tree-select :data="treeData" v-model="treeSelected" @on-select-change="handleTreeSelectClick"></tree-select>
				</FormItem>
				<FormItem label="名称">
					<Input v-model="projectTypeItem.name"></Input>
				</FormItem>
				<FormItem>
					<Button type="primary" @click="saveProjectType">保存</Button>
				</FormItem>
			</Form>
		</Modal>

	</div>
</template>
<script>
	import project from "@/api/project.js";
	import treeSelect from "_c/tree-select"
	import {
		hasOneOf
	} from "@/libs/tools";
	export default {
		components: {
			treeSelect
		},
		data() {
			return {
				treeSelected: [],
				addProjectTypeModal: false,
				addProjectTypeModalTitle: '',
				projectTypeList: [],
				treeData: [],
				projectTypeCloumn: [{
						title: "类型名称",
						key: "name",
						align: "center",
						tree: true,
						minWidth: 220
					},
					{
						title: "操作",
						align: "center",
						slot: "action",
						minWidth: 220
					},

				],
				projectTypeItem: {}
			};
		},
		methods: {
			hasRole(roles) {
				return hasOneOf(this.$store.state.user.role, roles);
			},
			addProjectType() {
				this.addProjectTypeModal = true;
				this.projectTypeItem = {};
				this.treeSelected=[];
				this.addProjectTypeModalTitle = "添加任务类型";
			},
			remove(row) {
				project.deleteProjectType(row.id).then(res => {
					this.getProjectTypeList();
				});
			},
			getProjectTypeList() {
				project.getProjectTypeList().then(res => {
					this.projectTypeList = res.data;
					this.treeData = this.projectTypeList.filter(x => !x.parentId).map(this.MapChild)
					console.log(this.treeData)
				})
			},
			MapChild(x) {
				x.children = [];
				x.children = this.projectTypeList.filter(y => y.parentId == x.id).map(this.MapChild);
				x.title = x.name;

				return x;
			},
			saveProjectType() {
				let _this = this;
				if (this.projectTypeItem.name) {
					project.addProjectType(this.projectTypeItem).then(res => {
						_this.getProjectTypeList();
						_this.$Message.success("保存成功");
						_this.addProjectTypeModal = false;
					})
				}
			},
			handleTreeSelectClick(selectArray, item) {
				this.treeSelected = selectArray.map(x => {
					return x.id
				})
				this.projectTypeItem.parentId=this.treeSelected[0];
			}
		},
		mounted() {
			this.getProjectTypeList();
		}
	};
</script>
